import React, { useEffect } from "react";
import searoadImage from "../../assets/img/carousel/1004Searoad.png";

function SeawayInfo() {
  useEffect(() => {
    const previousTitle = document.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    const previousDescription = metaDescription
      ? metaDescription.getAttribute("content")
      : "";

    document.title = "여객선 운항정보 안내 | 코끼리협동조합";
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "천사뱃길 앱 지원은 종료되었으며, 2024 스마트빌리지 사업으로 병풍도·대기점도·소악도에서 운항·안전 정보를 지속 안내합니다."
      );
    }

    return () => {
      document.title = previousTitle;
      if (metaDescription) {
        metaDescription.setAttribute("content", previousDescription || "");
      }
    };
  }, []);

  return (
    <div className="2xl:w-[60%] w-[90%] mx-auto md:mt-10 mt-5 flex flex-col md:gap-10 gap-6 leading-7">
      <div className="flex flex-col gap-4 p-4 rounded-lg md:p-6 md:flex-row md:items-center bg-boxbg">
        <div className="w-full md:w-1/3">
          <img
            src={searoadImage}
            alt="천사뱃길"
            className="object-cover w-full rounded-lg"
          />
        </div>
        <div className="flex flex-col w-full gap-2 md:w-2/3">
          <p className="text-base font-semibold md:text-2xl">
            여객선 운항정보 안내
          </p>
          <p className="text-sm text-gray-600 md:text-base">
            코끼리협동조합은 2021년부터 신안군 일부 여객항로의 운항 정보를
            제공해 왔습니다.
            <br />
            과거에는 모바일 앱 '천사뱃길'을 통해 안내했으나, 앱 지원은
            종료되었습니다.
            <br />
            현재는 병풍도·대기점도·소악도 선착장 안내 단말기 3대로 운항·안전
            정보를 지속 안내하고 있으며, 2024년 스마트빌리지 사업을 수주하여
            운영을 이어가고 있습니다.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <p className="text-lg font-semibold md:text-xl">운영 현황</p>
        <ul className="text-sm text-gray-700 list-disc list-inside md:text-base">
          <li>앱(천사뱃길) 지원 종료</li>
          <li>
            병풍도·대기점도·소악도 선착장 안내 단말기 3대로 운항·안전 정보
            지속 안내
          </li>
          <li>2024년 스마트빌리지 사업 수주</li>
        </ul>
        <p className="text-xs text-gray-500 md:text-sm">
          운항 정보는 기상 및 현장 상황에 따라 변동될 수 있습니다.
        </p>
      </div>

      <div>
        <a
          href="https://searoad.co77iri.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-gray-950 rounded-full hover:opacity-80 md:text-base"
        >
          천사뱃길 홈페이지 바로가기
        </a>
      </div>

      <div className="flex flex-col gap-3">
        <p className="text-lg font-semibold md:text-xl">FAQ</p>
        <details className="p-4 rounded-lg bg-boxbg">
          <summary className="text-sm font-semibold cursor-pointer md:text-base">
            천사뱃길 앱이 없어졌나요?
          </summary>
          <p className="mt-2 text-sm text-gray-700 md:text-base">
            모바일 앱 지원은 종료되었습니다. 운항·안전 정보 안내는 2024
            스마트빌리지 사업으로 병풍도·대기점도·소악도에서 계속 제공됩니다.
          </p>
        </details>
        <details className="p-4 rounded-lg bg-boxbg">
          <summary className="text-sm font-semibold cursor-pointer md:text-base">
            어디에서 확인할 수 있나요?
          </summary>
          <p className="mt-2 text-sm text-gray-700 md:text-base">
            본 홈페이지와 천사뱃길 웹페이지, 그리고 병풍도·대기점도·소악도
            선착장 안내 단말기에서 확인할 수 있습니다.
          </p>
        </details>
      </div>
    </div>
  );
}

export default SeawayInfo;
